import { CORS } from 'root/utils/cors/cors';

const hashedEmail = {
    get: function (email, callback) {
        CORS.xdr(
            '/rest/sec/hash',
            'POST',
            email,
            function (data) {
                callback(hashedEmail.getJSON(data));
            },
            function (err) {
                callback(err);
            }
        );
    },
    getJSON: function (str) {
        var json;
        try {
            json = JSON.parse(str);
        } catch (e) {
            return false;
        }
        return json;
    },
};

export { hashedEmail };
